import React, { Component } from 'react';

class NewCustomerForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      customer: {
        id: null,
        name: null,
        loginCode: null,
      },
    }

    this.submit = this.submit.bind(this);
  }

  handleChangeOfField(field, e) {
    const customer = { ...this.state.customer };
    customer[field] = e.target.value;
    this.setState({ customer });
  }

  submit(e) {
    e.preventDefault();
    this.props.database.ref(`customers/${this.state.customer.id}`).set({
      name: this.state.customer.name,
      loginCode: this.state.customer.loginCode,
      createdAt: new Date(),
    });
    this.setState({
      customer: {
        id: null,
        name: null,
        loginCode: null,
      }
    })
  }

  render() {
    return (
      <div className="pt-card">
        <h3>Neuen Kunden anlegen</h3>
        <form onSubmit={this.submit}>
          <label className="pt-label">
            ID
            <input
              className="pt-input"
              type="text"
              value={this.state.customer.id || ''}
              placeholder="Wird später automatisch erzeugt"
              onChange={(e) => this.handleChangeOfField('id', e)}
            />
          </label>
          <label className="pt-label">
            Name
            <input
              className="pt-input"
              type="text"
              value={this.state.customer.name || ''}
              placeholder="Firmenbezeichnung"
              onChange={(e) => this.handleChangeOfField('name', e)}
            />
          </label>

          <label className="pt-label">
            LoginCode
            <input
              className="pt-input"
              type="text"
              value={this.state.customer.loginCode || ''}
              placeholder="Firmenbezeichnung"
              onChange={(e) => this.handleChangeOfField('loginCode', e)}
            />
          </label>


          <button type="submit" className="pt-button pt-intent-success">
            Erstellen
          </button>
        </form>
      </div>
    );
  }
}

export default NewCustomerForm;



/** WEBPACK FOOTER **
 ** ./src/NewCustomerForm.js
 **/